<script>
  import { onMount, onDestroy } from "svelte";
  import Badge from '../Badge.svelte';
  import { createEventDispatcher } from 'svelte';
  import { debounce, find } from 'lodash';
import CustomIcon from "../CustomIcon.svelte";

  const debounceTimeMs = 700;

  const dispatch = createEventDispatcher();

  export let getKey = (rec) => {
    return rec['key'];
  };
  export let getName = (rec) => {
    return rec['name'];
  };
  export let editPlaceholder = 'Search for a value';
  export let options = [];
  export let values = [];
  export let id = "";
  export let emptyMessage = ""
  export let onChange = (values) => {};

  let searchTerm = '';
  let editMode;
  let showAutoComplete;
  let highlightedOption = 0;
  let filteredOptions;
  

  $: filteredOptions = options.filter(
    (val) => {
      const isExist = find(values, (value) => value.iab_category_id === val.iab_category_id)
      return getName(val).toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1 && !isExist
    }
  );

  function onInput(ev) {
    if (ev.code == 'Enter') {
      ev.preventDefault();
      if (filteredOptions.length > 0) {
        onSelected(filteredOptions[0]);
      }
      searchTerm = '';
    }

    if (searchTerm.length > 0) {
      onSearch(searchTerm);
      showAutoComplete = true;
    } else {
      showAutoComplete = false;
    }
  }

  const onSearch = debounce((searchTerm) => {
    dispatch('search', searchTerm);
  }, debounceTimeMs);

  function onFocus() {
    showAutoComplete = true;
    setTimeout(() => {
      document.getElementById('select-input').focus()  
    }, 100);
  }

  function onBlur() {
    showAutoComplete = false;
  }

  function optionsInit(el) {
    el.focus()
  }

  function onSelected(val) {
    searchTerm = '';
    showAutoComplete = false;
    values = [...values, val];
    options = removeItem(options, val);
    onChange(values);
  }

  function onUnselect(val) {
    values = removeItem(values, val);
    options = [...options, val];
    onChange(values);
  }

  function removeItem(list, val) {
    let i = 0;
    for (const l of list) {
      if (getKey(l) == getKey(val)) {
        return [...list.slice(0, i), ...list.slice(i + 1)];
      }
      i++;
    }
    return list;
  }

  function onClickOutside(e) {
    if (document.getElementById('clickbox').contains(e.target)){
      
    } else{
      onBlur()
    }
  }

  onMount(() => {
    window.addEventListener('click', onClickOutside);
  })
  onDestroy(() => {
    window.removeEventListener('click', onClickOutside);
  })
</script>

<div class="border border-field-border-gray rounded-md px-2">
  <div class="py-2" id="clickbox">
    <div class="">
      <div class="mt-1 relative rounded-md shadow-sm">
        <input
          id="select-input"
          type="text"
          bind:value={searchTerm}
          on:input|preventDefault={onInput}
          on:focus={onFocus}
          placeholder={editPlaceholder}
          class="focus:ring-yellow-500 focus:border-yellow-500 block w-full pr-10 sm:text-sm border-gray-300 rounded-md"
        />
        {#if searchTerm.length > 0}
          <div
            class="absolute inset-y-0 right-0 pr-3 flex items-center"
            on:click={() => {
              searchTerm = '';
            }}
          >
            <!-- <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 cursor-pointer"
              fill="none"
              viewBox="0 0 24 24"
              stroke="fillcolor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg> -->
            <CustomIcon name="m_close" color="rgba(51, 51, 51,0.5)" />
          </div>
        {/if}
      </div>
    </div>
    {#if searchTerm.length > 0 || showAutoComplete}
      <ul
        class=" max-w-lg w-full absolute z-10 mt-1 bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
        tabindex="-1"
        role="listbox"
        aria-labelledby="listbox-label"
        aria-activedescendant="listbox-option-3"
        use:optionsInit
      >
        <!--
            Select option, manage highlight styles based on mouseenter/mouseleave and keyboard navigation.
    
            Highlighted: "text-white bg-indigo-600", Not Highlighted: "text-gray-900"
          -->
        {#each filteredOptions as option, i (getKey(option))}
          <li
            class="text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9 hover:bg-purple-300"
            id="listbox-option-0"
            role={option}
            on:click={() => onSelected(filteredOptions[i])}
            class:bg-purple-300={i === highlightedOption}
          >
            <div class="flex">
              <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
              <span class="font-normal truncate">
                {getName(option)}
              </span>
            </div>
          </li>
        {/each}
        <!-- More items... -->
      </ul>
    {/if}
    <div class="mt-2 col-span-2">
      {#if values}
        {#each values as val, i (i)}
          <Badge label={getName(val)} onRemove={() => onUnselect(val)} />
        {/each}
      {/if}
    </div>
  </div>
</div>
